import { BehaviourType } from "entities/App/model/types";
import { ShipmentType, ShipmentTypeKey } from "entities/shared/shipmentCard.types";
import { ValueOf } from "shared/lib/typeCheck.lib";

export type AppInputRawData = {
  lang?: string;
  platform?: number | string | undefined;
  height?: string;
  hideCardSearch?: boolean | string;
  hideCardShippingLine?: boolean | string;
  shadowDom?: boolean | string;
  tokenUrl?: string;
  shipment_type?: ShipmentTypeKey[];
  urlBehaviour?: ValueOf<typeof BehaviourType>;
  authData?: {
    urlFacebook?: string;
    urlGoogle?: string;
    urlApple?: string;
  };
};

export type AppInputParsedData = {
  lang: string;
  platform: number | undefined;
  height?: string;
  hideCardSearch: boolean;
  hideCardShippingLine: boolean;
  shadowDom: boolean;
  tokenUrl?: string;
  allowedShipmentTypes: ValueOf<typeof ShipmentType>[];
  urlBehaviour: ValueOf<typeof BehaviourType>;
  authData: {
    urlFacebook: string;
    urlGoogle: string;
    urlApple: string;
  };
};
